module.exports = "https://www.gc-pro.gnp.com.mx/1c4b8cda6fd58b61645089f91880b76b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-search.svg
// module id = 8129
// module chunks = 0